<template>
  <div class="linked-project-stage-fee-view" :class = "{'clear-header':isWechatBrowser}">
    <my-header title="项目账单详情" v-if="!isWechatBrowser" :showBack="true"></my-header>
    <div class="case-persons">
      <div v-if="stageFeeType == '2'" class="case-person" @click="DetailPerson(foreman)">
        <img class="cp-img" :src="imgUrl + foreman.avatar">
        <div class="cp-right">
          <div class="cpr-name" >工长:{{onestopProject.foremanName}}</div>
          <div class="person-evaluate">
            评分:
            <div class="star-img" :class="foreman.score <= 0 ? '' : (foreman.score >=1 ? 'on':(foreman.score >0 && foreman.score <1 ? 'half':''))"></div>
            <div class="star-img" :class="foreman.score <= 1 ? '' : (foreman.score >=2 ? 'on':(foreman.score >1 && foreman.score <2 ? 'half':''))"></div>
            <div class="star-img" :class="foreman.score <= 2 ? '' : (foreman.score >=3 ? 'on':(foreman.score >2 && foreman.score <3 ? 'half':''))"></div>
            <div class="star-img" :class="foreman.score <= 3 ? '' : (foreman.score >=4 ? 'on':(foreman.score >3 && foreman.score <4 ? 'half':''))"></div>
            <div class="star-img" :class="foreman.score <= 4 ? '' : (foreman.score >=5 ? 'on':(foreman.score >4 && foreman.score <5 ? 'half':''))"></div>
            <img class="icon-enter-detail" src="../../assets/index/enter.png" @click="DetailPerson(foreman)">
          </div>
          <div class="cpr-authentication">
            <span v-if="foreman.auth == '1'" style="margin-right: 0.2rem;display: flex;align-items: center">
              <img class="icon-img" src="../../assets/gangmaster/icon-ensure.png">
              平台认证
            </span>
            <img class="icon-img" src="../../assets/gangmaster/icon-identification.png">
            {{foreman.guaranteeMoney == null ? 0 : foreman.guaranteeMoney}}万
          </div>
        </div>
      </div>
      <div v-if="stageFeeType == '6'" class="case-person" @click="DetailPerson(supervisor)">
        <img class="cp-img" :src="imgUrl + supervisor.avatar">
        <div class="cp-right">
          <div class="cpr-name">设计师:{{onestopProject.designerName}}</div>
          <div class="person-evaluate">
            评分:
            <div class="star-img" :class="supervisor.score <= 0 ? '' : (supervisor.score >=1 ? 'on':(supervisor.score >0 && supervisor.score <1 ? 'half':''))"></div>
            <div class="star-img" :class="supervisor.score <= 1 ? '' : (supervisor.score >=2 ? 'on':(supervisor.score >1 && supervisor.score <2 ? 'half':''))"></div>
            <div class="star-img" :class="supervisor.score <= 2 ? '' : (supervisor.score >=3 ? 'on':(supervisor.score >2 && supervisor.score <3 ? 'half':''))"></div>
            <div class="star-img" :class="supervisor.score <= 3 ? '' : (supervisor.score >=4 ? 'on':(supervisor.score >3 && supervisor.score <4 ? 'half':''))"></div>
            <div class="star-img" :class="supervisor.score <= 4 ? '' : (supervisor.score >=5 ? 'on':(supervisor.score >4 && supervisor.score <5 ? 'half':''))"></div>
            <img class="icon-enter-detail" src="../../assets/index/enter.png" @click="DetailPerson(supervisor)">
          </div>
          <div class="cpr-authentication">
            <span v-if="supervisor.auth == '1'" style="margin-right: 0.2rem;display: flex;align-items: center">
              <img class="icon-img" src="../../assets/gangmaster/icon-ensure.png">
              平台认证
            </span>
            <img class="icon-img" src="../../assets/gangmaster/icon-identification.png">
            {{supervisor.guaranteeMoney == null ? 0 : supervisor.guaranteeMoney}}万
          </div>
        </div>
      </div>
    </div>
    <div class="work-progress" v-if="stageFeeType == '2'">
      <div class="wp-title">
        <div class="wp-title-item selected">
          <div class="text">项目账单</div>
          <div class="border-bottom"></div>
        </div>
      </div>
      <div class="wp-body selected-body">
        <div class="bill-list">
          <div class="bill-item" v-for="fee in projectStageFee" v-if="(fee.type != '3') || (fee.type == '3' && fee.priceStage > 0)">
            <div v-if="(fee.type != '3') || (fee.type == '3' && fee.priceStage>0)" class="bill-info">
              <div class="bill-name">{{fee.name || '合同款'}}</div>
              <div class="bill-status-uncreate" v-if="!fee.priceStage">等待工长发起</div>
              <div class="bill-status-prepay" v-if="fee.status == '0' && fee.priceStage">待支付</div>
              <div  class="bill-status-prepay" v-if="stageFee.id == fee.id && customerPayVoucher.stageFeeId == fee.id">{{payVoucherStatus}}</div>
              <div  class="bill-status-paid" v-if="fee.status == '1'">已支付</div>
            </div>
            <div class="bill-status-uncreate" v-if="!fee.priceStage">待生成</div>
            <div class="bill-amount" v-if="fee.priceStage">￥{{fee.priceStage}}</div>
          </div>
        </div>
        <div class="pre-payment-btn" v-if="stageFee.payType != '3' && stageFee.priceStage" @click="openConfirmPaymentOnestop(onestopProject.id,onestopProject.status,onestopProject.type)">支 付</div>
        <div class="pre-payment-btn" v-if="stageFee.payType == '3' && customerPayVoucher.checkStatus == '3'" @click="openConfirmPaymentOnestop(onestopProject.id,onestopProject.status,onestopProject.type)">重新上传支付凭证</div>
        <div style="clear: both"></div>
        <div style="padding-top: 0.1rem">上传合同明细凭证 <span style="color: #FF7544">(注意：最多上传30张)</span></div>
        <div class="record-img">
          <div class="image-area">
            <div class="image-view">
              <div v-if="attachmentUrlList.length>0" v-for="(recoredImg,index) in attachmentUrlList">
                <div class="image" :data-index="index" style="position: relative">
                  <img @click="deleteImages(index)" style="width: 0.3rem;height: 0.3rem;position: absolute;right: -0.18rem;top: -0.18rem;" src="../../assets/icon/icon-image-del.png">
                  <img :src="imgUrl+recoredImg" @click = "previewImg(imgUrl+recoredImg,attachmentUrlList)">
                </div>
              </div>
              <div v-if="attachmentUrlList.length<30">
                <div class="image add-image" @click.stop="addCompleteImgs()">
                  <span class="icon-plus"><img src="../../assets/icon/icon-plus.png"></span>
                  <span style="display: none;"><input type="file" class="image-input" multiple accept="image/*"></span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div v-if="showContractSaveBtn" style="padding: 0 0.4rem;
          height: 0.61rem;
          margin: 0.5rem 0.2rem 0.3rem 0;
          line-height: 0.61rem;
          background-color: #1D8AE7;
          border-radius: 0.4rem;
          font-size: 0.28rem;
          color: white;
          text-align: center;" @click="saveCustomerContractImages()">提交合同明细凭证</div>
      </div>
    </div>
    <div class="work-progress" v-if="stageFeeType == '6'">
      <div class="wp-title">
        <div class="wp-title-item selected">
          <div class="text">项目账单</div>
          <div class="border-bottom"></div>
        </div>
      </div>
      <div class="wp-body selected-body">
        <div class="bill-list">
          <div class="bill-item" v-for="fee in projectStageFee" v-if="(fee.type != '3') || (fee.type == '3' && fee.priceStage > 0)">
            <div class="bill-info">
              <div class="bill-name" v-if="fee.percent">{{fee.name || '合同款'}}{{fee.percent * 100}}%</div>
              <div class="bill-name" v-if="!fee.percent">{{fee.name || '合同款'}}</div>
              <div class="bill-status-prepay" v-if="fee.status == '0'">待支付</div>
              <div  class="bill-status-prepay" v-if="stageFee.id == fee.id && customerPayVoucher.stageFeeId == fee.id">{{payVoucherStatus}}</div>
              <div  class="bill-status-paid" v-if="fee.status == '1'">已支付</div>
            </div>
            <div class="bill-amount" v-if="fee.priceStage">￥{{fee.priceStage}}</div>
          </div>
        </div>
        <div class="pre-payment-btn" v-if="stageFee.payType != '3' && stageFee.priceStage" @click="openConfirmPaymentOnestop(onestopProject.id,onestopProject.status,onestopProject.type)">支 付</div>
        <div class="pre-payment-btn" v-if="stageFee.payType == '3' && customerPayVoucher.checkStatus == '3'" @click="openConfirmPaymentOnestop(onestopProject.id,onestopProject.status,onestopProject.type)">重新上传支付凭证</div>
        <div style="clear: both"></div>
      </div>
    </div>
  </div>
</template>
<style lang="scss">
  .linked-project-stage-fee-view{
    background-color: #F3F8FC;
    font-size: 0.28rem;
    .color-gray{
      color: #878E99;
    }
    .color-black{
      color: #1B1E29;
    }
    .color-blue{
      color: #1D8AE7;
    }
    .color-orange{
      color: #FF7544;
    }
    .case-info{
      position: relative;
      width: calc(100% - 0.56rem);
      height: 1.26rem;
      padding: 0 0.28rem;
      background-color: white;
      border-bottom: solid 0.02rem #DAE2E5;

      .ci-name-status{
        color: #1D8AE7;
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding-top: 0.22rem;

        .ci-name{
          font-size: 0.32rem;
          color: black;
        }
      }

      .ci-size{
        color: #878E99;
        font-size: 0.24rem;
        text-align: left;
        padding-top: 0.1rem;
      }
      .visit-reserve-btn{
        position: absolute;
        top:0.7rem;
        right: 0.28rem;
        width: 1.4rem;
        height: 0.5rem;
        line-height: 0.55rem;
        background: #1d8ae7;
        text-align: center;
        color: white;
        border-radius: 0.5rem;
        font-size: 0.24rem;
      }
    }
    .case-persons {
      background-color: white;
      margin-bottom: 0.2rem;
      .case-person {
        margin-left: 0.28rem;
        padding: 0.28rem 0.28rem 0.28rem 0;
        border-bottom: solid 0.02rem #DAE2E5;
        display: flex;

        .cp-img{
          width: 1.51rem;
          height: 1.51rem;
          border-radius: 2rem;
        }

        .cp-right{
          flex-grow: 1;
          padding-left: 0.38rem;
          text-align: left;

          .cpr-name{
            padding-top: 0.1rem;
            font-size: 0.32rem;
            color: #1B1E29;
            display: flex;
            justify-content: space-between;
            align-items: center;
          }
          .person-evaluate{
            font-size: 0.32rem;
            position: relative;
            display: flex;
            justify-content: flex-start;
            align-items: center;
          .star-img {
            width: 0.32rem;
            height: 0.3rem;
            margin-left: 0.1rem;
            background-image: url("../../assets/gangmaster/icon-star-off.png");
            background-size: 100%;
          }
          .on{
            background-image: url(../../assets/gangmaster/icon-star-on.png);
          }
          .half{
            background-image: url(../../assets/gangmaster/icon-star-half.png);
          }
          .off{
            background-image: url(../../assets/gangmaster/icon-star-off.png);
          }

          .icon-enter-detail{
            width: 0.19rem;
            position: absolute;
            right: 0.32rem;
          }
        }

          .cpr-authentication{
            color: #878E99;
            display: flex;
            align-items: center;
            padding-top: 0.2rem;

            .icon-img{
              width: 0.3rem;
              height: 0.34rem;
              margin-right: 0.1rem;
            }
          }
        }
      }
    }
    .work-progress{
      width: calc(100% - 0.28rem);
      padding-left: 0.28rem;
      padding-bottom: 0.5rem;
      background-color: white;
      text-align: left;
      .wp-title{
        height: 0.9rem;
        font-size: 0.32rem;
        line-height: 0.9rem;
        margin-bottom: 0.3rem;
        color: #1B1E29;
        border-bottom: 1px solid #D5DEE2;
        display: flex;
        flex-flow: row nowrap;
        .wp-title-line{
          width: 0.03rem;
          height: 0.46rem;
          background-color: #1D8AE7;
          margin-left: 1.08rem;
          margin-right: 1.08rem;
        }
        .wp-title-item{
          position: relative;
          color: #878E99;
          padding-left: 0.2rem;
          padding-right: 0.2rem;
          .text{
            position: relative;
            width: 100%;
            height: 100%;
            display: flex;
            flex-flow: row nowrap;
            justify-content: center;
            align-items: center;
          }
          .border-bottom{
            position: absolute;
            width: 1.1rem;
            height: 0;
            top: 100%;
            left: 50%;
            margin-top: -0.05rem;
            margin-left: -0.61rem;
            border: 0.06rem solid transparent;
            border-top: none;
          }
        }
        .selected{
          .text{
            color: #1D8AE7;
          }
          .border-bottom{
            border-bottom: 0.06rem solid #1D8AE7;
          }
        }
      }
      .wp-body{
        display: none;
        &.selected-body{
          display: block;
        }

        .bill-list{
          margin-top: -0.3rem;
          margin-right: 0.3rem;
          .bill-item{
            padding-bottom: 0.3rem;
            padding-right: 0.3rem;
            padding-top: 0.3rem;
            border-bottom: solid 1px #d5dee2
          }
          .bill-info{
            display: flex;
            justify-content: space-between
          }
          .bill-name{
            color: #1b1e29;
            font-size: 0.22rem
          }
          .bill-status-uncreate{
            color: #808a9a;
          }
          .bill-status-prepay{
            color: #ff7544;
          }
          .bill-status-paid{
            color: #1d8ae7;
          }
          .bill-amount{
            font-size: 0.56rem;
            color: #ff7544
          }
        }
        .pre-payment-btn{
          padding: 0 0.4rem;
          height: 0.61rem;
          margin: 0.5rem 0.2rem 0.3rem 0;
          line-height: 0.61rem;
          background-color: #1D8AE7;
          border-radius: 0.4rem;
          font-size: 0.28rem;
          color: white;
          text-align: center;
          float: right;
        }

        .image-view {
          display: flex;
          flex-flow: row wrap;
          margin-top: 0.1rem;
          padding-bottom: 0.2rem;

          .image {
            width: 1.64rem;
            height: 1.64rem;
            background: #F3F8FC;
            margin-bottom: 5px;
            margin-right: 14px;

            &.add-image {
               display: flex;
               flex-flow: row wrap;
               justify-content: center;
               align-items: center;
               color: #999;
             }

            .icon-plus img {
              width: 0.8rem;
              height: 0.8rem;
              position: relative;
            }

            img {
              width: 100%;
              height: 100%;
            }

          }
        }
      }

      .wp-row{
        margin-top: 0.6rem;
        display: flex;
        flex-flow: row nowrap;
        justify-content: space-between;
        align-items: center;
        .wp-label{
          position: relative;
          width: 0.34rem;
          height: 0.34rem;
          border: .04rem solid #D5DEE2;
          border-radius: 50%;
          flex-grow: 0;
          flex-shrink: 0;
          z-index: 1111;
          &:after{
             content: ' ';
             height: 0.66rem;
             width: 0.04rem;
             background-color: #D5DEE2;
             display: block;
             position: absolute;
             top: -100%;
             margin-top: -0.32rem;
             left: 50%;
             margin-left: -0.025rem;
           }
          &.active{
             border-color:#1D8AE7;
             z-index: 1111;
            &:after{
               background-color: #1D8AE7;
             }
          }
        }
        &:first-child{
           margin-top:0px;
          .wp-label{
            &:after{
               display: none;
             }
          }
        }
        .wp-content{
          margin-left: 0.3rem;
          color: #1B1E29;
          font-size: 0.28rem;
          flex-grow: 1;
          flex-shrink: 0;
        }
        .wp-info{
          margin-right: 0.3rem;
          flex-grow: 0;
          flex-shrink: 0;
          display: flex;
          flex-flow: row nowrap;
          justify-content: start;
          align-items: center;
        .info-time{
          font-size: 0.2rem;
          color: #D5DEE2;
          margin-right: 0.33rem;
        }
        .info-status{
          width: 0.32rem;
          height: 0.32rem;
          display: block;
        }
      }
      .color-gray{
        color: #878E99;
      }
      .color-blue{
        color: #1D8AE7;
      }
      .color-black{
        color: #1B1E29;
      }

      .row-left{
        display: flex;
        align-items: center;
        color: #878E99;

      img{
        width: 0.54rem;
        height: 0.54rem;
        margin-right: 0.19rem;
      }
      }

      .row-right{
        text-align: right;
        padding-right: 0.28rem;
        font-size: 0.2rem;
      }
      }
      .project-patroled-uninspected{
        display: flex;
        justify-content: space-between;
        padding-top: 0.1rem;
        padding-bottom: 0.1rem;
        margin-left: 0.18rem;
        padding-left: 0.45rem;
        border-left: solid 2px #D5DEE2;
      }
      .project-unpatrol{
        height: 0.3rem;
        padding-top: 0.2rem;
        margin-left: 0.2rem;
        padding-left: 0.45rem;
        border-left: solid 2px #D5DEE2;
      }
      .border-inspeced{
        border-left: solid 2px #1D8AE7;
      }
      .patrol-content{
        font-size: 0.28rem;
        color: #FF7544
      }
      .patrol-time{
        font-size: 0.2rem;
        color: #D5DEE2;
        margin-right: 0.95rem;
      }
    }
    .border-top-0{
      border-top: 0 !important;
    }
    .border-top-style{
      border-top: solid 0.02rem #D5DEE2;
    }
    .pb-money-row-style{
      .row-left{
        height: 0.32rem !important;
      }
    }
    .wait-send{
      pointer-events: none;
    }
    .clear-header{
      margin-top: -1rem;
    }

  }
</style>

<script>
  import {imgUrl,shareIcon} from '../../config'
  import {MessageBox,Indicator,Toast} from 'mint-ui'
  import Header from '../../components/header/Header'
  import ProjectService from '../../service/customer/ProjectService'
  import SupervisorService from '../../service/SupervisorService'
  import customerPayVoucherService from '../../service/customer/CustomerPayVoucherService'
  import Preview from '../../components/preview/preview'
  import baseService from '../../service/BaseService'

  export default {
    name: 'OnestopProjectDetail',
    components: {
      'my-header': Header,
      'preview': Preview,
    },
    data () {
      return {
        onestopProject:{},
        foreman:{},
        supervisor:{},
        projectStage:[],
        stage:{},//当前工地验收进度
        projectStageFee:[],
        customerPayVoucher:{},
        payVoucherStatus:'',
        stageFee:{},//当前该支付的阶段
        imgUrl:imgUrl,
        shareIcon:shareIcon,
        textArea:'',
        evaluateWho:1,
        stageFeeType:'2',
        isWechatBrowser:this.$verfyBrowserType(),
        projectName:'',
        sheetVisible:false,
        actions:[],
        showImage:'',
        showBig:false,
        showContractSaveBtn:false,
        attachmentUrlList:[],
        customerContractImages:'',
      }
    },
    created(){
      this.onestopProject.id = this.$route.query.onestopProjectId || '';
      this.stageFeeType = this.$route.query.stageFeeType;
    },
    beforeMount () {
      document.title = this.$route.meta.title;
      this.getOnestopProjectDetail(this.onestopProject.id);
    },
    methods: {
      DetailPerson(person){
        let supervisorId = person.id;
        let supervisorName = person.name;
        if(person.type == '2') {
          this.$router.push({name: 'GangmasterDetail', query: {supervisorId, supervisorName}});
        }if (person.type == '5'){
          this.$router.push({name:'DesignerDetail',query:{supervisorId,supervisorName}});
        }
      },
      async getOnestopProjectDetail(id){//整包项目详情
        var result=await ProjectService.getOnestopProjectDetail(id);
        if(result.code == 0){
          this.onestopProject = result.data;
          this.onestopStatusMap = this.onestopProject.onestopStatusMap;
          this.projectName = this.onestopProject.name;

          if(this.onestopProject.customerContracts){
            this.customerContractImages = this.onestopProject.customerContracts;
            this.attachmentUrlList = this.customerContractImages.split(',')
          }else {
            this.showContractSaveBtn = true;
            this.attachmentUrlList = [];
          }

          if(this.onestopProject.foremanId && this.stageFeeType == '2'){
            this.getForemanInfo(this.onestopProject.foremanId);
            this.getProjectStageFee(this.onestopProject.foremanId);
          }
          if(this.onestopProject.designerId && this.stageFeeType == '6'){
            this.getSupervisorInfo(this.onestopProject.designerId);
            this.getProjectStageFee(this.onestopProject.designerId);
          }
        }else {
          Toast('获取整包项目详情信息失败');
        }
      },
      async getForemanInfo(id){
        var result=await SupervisorService.getSupervisorDetail(id);
        if(result.code == 0){
          this.foreman=result.data;
          console.info("工长详细信息",this.foreman);
        }else {
          console.info('获取工长详细信息失败');
        }
      },
      async getSupervisorInfo(id=''){
        var result = await SupervisorService.getSupervisorDetail(id);
        if (result.code == 0) {
          this.supervisor = result.data;
          console.info("监理详细信息", this.supervisor);
        } else {
          console.info('获取监理详细信息失败');
        }
      },
      async getProjectStageFee(supervisorId){
        //整包项目的收费列表
        var result = await ProjectService.getOnestopProjectStageFee(this.onestopProject.id,supervisorId);
        if(result.code == 0){
          this.projectStageFee=result.data.projectStageFeeList;
          console.info(this.projectStageFee)
          for(let psf of this.projectStageFee){
            if(psf.status != '1'){
              this.stageFee = psf;
              break;
            }
          }
          if(this.stageFee.payType == '3'){
            let {code,msg,data} = await customerPayVoucherService.newest(this.onestopProject.id);
            if(code == '0'){
              this.customerPayVoucher = data;
              if(this.customerPayVoucher.checkStatus == '1'){
                this.payVoucherStatus = '凭证待审核';
              } else if(this.customerPayVoucher.checkStatus == '3'){
                this.payVoucherStatus = '凭证审核不通过';
              }
              console.info(this.payVoucherStatus)
            }
          }
        }else {
          Toast('获取收费列表信息失败');
        }
      },
      async saveCustomerContractImages(){
        if(!this.customerContractImages){
          Toast('请上传合同明细凭证!');
          return
        }
        if(this.customerContractImages.startsWith(',')){
          this.customerContractImages = this.customerContractImages.substring(1,this.customerContractImages.length);
        }
        console.info(this.customerContractImages)
        let {code} = await ProjectService.saveCustomerContracts(this.onestopProject.id,this.customerContractImages);

        if(code == '0') {
          Toast('合同明细凭证提交成功!');
          this.getOnestopProjectDetail(this.onestopProject.id);
          this.showContractSaveBtn = false
        }else {
          Toast('合同明细凭证提交失败!请重新上传!');
          this.contractImages = '';
        }
      },

      //跳转支付整包、监理或工长阶段收费页
      openConfirmPaymentOnestop(onestopProjectId,projectStatus,projectType){
        if(projectStatus == '7'){
          Toast('您的项目已终止!')
        }else{
          this.$router.push({name:'ConfirmPayLinkedBill',query:{projectId:onestopProjectId,stageFeeType:this.stageFeeType}});
        }
        this.global.tabItemSelect = this.tabItemSelect;
      },
      async addCompleteImgs(){
        var that = this;
       if(this.onestopProject.status == '7'){
          Toast('该项目已终止!');
          return
        }else {
          if(!!this.global.isMiniProgrm){
            baseService.uploadImageWxMini().then(res =>{
              //处理image,key
              console.info('res-----',res)
              baseService.downImage({mediaId:res}).then((url)=>{
                console.log('data',url);
                if(!that.showContractSaveBtn){
                  that.showContractSaveBtn = true
                }
                that.customerContractImages = that.customerContractImages + ',' +url.name;
                that.attachmentUrlList.push(url.name)
              });
            }).catch(err =>{
              console.log("小程序上传文件失败========",JSON.stringify(err));
              Indicator.close();
            });
          }else {
            //使用input文件选择
            var fileInput = document.querySelector(".image-input");
            fileInput.click();
            fileInput.onchange = function(){
              for(let file of this.files){
                let fileSize = file.size;
                if(fileSize > 0 && Math.round(fileSize/1024/1024*100)/100 < 20){
                  Indicator.open({
                    text: '加载中...',
                    spinnerType: 'fading-circle'
                  });
                  lrz(file,{width: 1024,fieldName:'imgFile',quality:0.6}).then((rst) =>{
                    return baseService.uploadImage(file);
                  }).then((url) => {
                    //处理image,key
                    console.info(url)
                    if(!that.showContractSaveBtn){
                      that.showContractSaveBtn = true
                    }
                    that.customerContractImages = that.customerContractImages + ',' +url.name;
                    that.attachmentUrlList.push(url.name)
                  }).catch((err) =>{
                    console.log("上传文件失败========",err);
                  }).always(()=>{
                    Indicator.close();
                  });
                }else {
                  Toast('请上传小于20M的图片!');
                }
              }
            }
          }
        }
      },
      deleteImages(index){
        var that= this;
        MessageBox.confirm('确定要删吗？删除后将无法恢复。')
          .then((action) => {
            let images = that.attachmentUrlList + '';
            let removeStr = that.attachmentUrlList[index];
            var recordImagesStr = '';
            var recordImagesArry  = images.split(",");
            for(var i=0; i<recordImagesArry.length; i++) {
              if(recordImagesArry[i] == removeStr) {
                recordImagesArry.splice(i, 1);
              }
            }
            if(recordImagesArry!=null) {
              for (var i = 0; i < recordImagesArry.length; i++) {
                recordImagesStr = recordImagesStr + ',' + recordImagesArry[i];
              }
              that.customerContractImages = recordImagesStr.substring(1, recordImagesStr.length);
            }
            that.attachmentUrlList = recordImagesArry;
            if(!that.showContractSaveBtn){
              that.showContractSaveBtn = true
            }
          }).catch(e =>{
          console.error("删除图片出错：",e);
        });
      },
      previewImg(currentImage,imageList){
        let previewImageList = [];
        for (let image of imageList){
          let previewImage = this.imgUrl + image;
          previewImageList.push(previewImage);
        }
        wx.previewImage({
          current: currentImage,
          urls: previewImageList
        });
      },
    }
  }
</script>

